import type { OnboardingValues, StepField } from "./types";

export const INITIAL_ONBOARDING_VALUES: OnboardingValues = {
  agentName: "",
  websiteUrl: "",
};

export const WEBSITE_URL_FIELD: StepField = {
  name: "websiteUrl",
  label: "Website URL",
  placeholder: "https://yourwebsite.com",
  required: true,
  type: "url",
};
